//  Name: paypal-button
import { replaceSpecial } from '@/helpers/utils'
const LIVE_URL = 'https://www.paypal.com/cgi-bin/webscr'
const SANDBOX_URL = 'https://www.sandbox.paypal.com/cgi-bin/webscr'

export default {
  props: {
    price: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    },
    notify: {
      required: false
    },
    sandbox: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    notify_url () {
      return 'https://api.pisciculturaglobal.com/courses/' + this.code + '/pay/paypal/'
    },
    return_url () {
      return 'https://campus.pisciculturaglobal.com/#/process/'
    },
    course () {
      return replaceSpecial(this.name)
    },
    url () {
      return (this.sandbox) ? SANDBOX_URL : LIVE_URL
    },
    sendNotify () {
      this.notify(2).then(() => {
        document.getElementById('paypal-form').submit()
      }, error => {
        console.log('Explosito!!!', error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/paypal-button/script.js